<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg">
                <img src="assets/svg/user-icon.svg" alt="Cambiar propietario">
            </div>
            <div>
                <h4 class="text-semibold">Cambiar propietario</h4>
                <h6 class="color-gray" style="font-weight: 400">
                    Selecciona el nuevo propietario para {{ data.count > 1 ? 'las tareas seleccionadas' : 'la tarea' }}.
                </h6>
            </div>
            <div>
                <img (click)="closeMdl()" class="close-button" src="assets/svg/close-icon.svg" alt="">
            </div>
        </div>
        
        <div class="mdl-body mt-4">
            <div class="step-content">
                <div class="mt-3">
                    <label class="login-label">
                        <p class="color-org d-inline">*</p>
                        Nuevo propietario:
                    </label>
                    <div class="crm-ng-select">
                        <ng-select
                            [items]="ejecutivos"
                            bindLabel="nombre"
                            bindValue="valor"
                            placeholder="Buscar usuario..."
                            [(ngModel)]="selectedOwner"
                            appendTo="body"
                        >
                            <ng-template ng-label-tmp let-item="item">
                                <div class="selected-option">
                                    <img src="assets/svg/user-icon.svg" alt="icono" class="dropdown-icon" />
                                    <span>{{ item.nombre }}</span>
                                </div>
                            </ng-template>

                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                <div class="dropdown-option">
                                    <img src="assets/svg/user-icon.svg" alt="icono" class="dropdown-icon" />
                                    <span>{{ item.nombre }}</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                
                <div *ngIf="data.count > 1" class="mt-3">
                    <p class="color-gray">
                        <strong>{{ data.count }}</strong> tareas serán asignadas al nuevo propietario.
                    </p>
                </div>
            </div>
        </div>

        <hr class="mt-5 mb-5">
        
        <div class="d-flex flex-row justify-center gap-20 mt-2">
            <button (click)="closeMdl()" class="btn btn-primary-outline">Cancelar</button>
            <button 
                class="btn btn-primary" 
                (click)="changeOwner()"
                [disabled]="!selectedOwner"
            >
                Cambiar propietario
            </button>
        </div>
    </div>
</div>